import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend, Tooltip, ReferenceLine,
} from 'recharts';
import './barChart.scss';
import {orderBy} from 'lodash';

class BarChartInLiquidationsByDays extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'daySelected': '',
    };
  }

  render() {
    const {liquidationsByDays} = this.props;
    const liquidationsOrderedByDay = orderBy(liquidationsByDays, ['day'], ['asc']);

    if (!liquidationsOrderedByDay.length) {
      return (
        <div className='without-data'>
          No hay información para el mes solicitado
        </div>
      );
    }
    return (
      <div className='liquidations chart-container'>
        <ResponsiveContainer width='100%' height={250}>
          <BarChart data={liquidationsOrderedByDay}
            margin={{'top': 30, 'right': 20, 'left': 0, 'bottom': 5}} maxBarSize={35}>
            <CartesianGrid strokeDasharray='3 3' />
            <XAxis dataKey='day' />
            <YAxis />
            
            <Tooltip />
            <Legend formatter={this.renderColorfulLegendText} />
            
            {this.renderLiquidationsBar()}
            {this.renderBilledBar()}
            {this.renderReferenceLine()}

          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }

  renderColorfulLegendText(value, entry) {
    const {color} = entry;
    
    return <span style={{color}}>{value}</span>;
  }

  renderLiquidationsBar() {
    return (
      <Bar dataKey={'liquidatedQuantity'} fill={'#109DFA'} name='Liquidaciones'
        onClick={this.handleDaySelectedClick.bind(this, 'liquidations')} />
    );
  }

  renderBilledBar() {
    return (
      <Bar dataKey='billedQuantity' fill={'#6DC36D'} name='Facturaciones'
        onClick={this.handleDaySelectedClick.bind(this, 'billings')} />
    );
  }

  handleDaySelectedClick(type, data) {
    this.setState({
      'daySelected': data.day,
    }, () => this.props.onClickDaySelected(data.day, type));
  }

  renderReferenceLine() {
    const {daySelected} = this.state;
    if (!daySelected) {
      return null;
    }
    return <ReferenceLine x={daySelected} stroke='red' />;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.liquidationsByDays.loading,
    'liquidationsByDays': state.liquidationsByDays.list,
  };
};

export default connect(mapStateToProps, {
})(BarChartInLiquidationsByDays);
